module.exports = "/_next/static/images/avatar_2-85e86c6cc569febc18071803f8897293.png";